<button #originRef (click)="showPopover()" [class.bg-hover]="dropdownOpen" class="button" mat-icon-button type="button">
  <mat-icon color="primary" svgIcon="mat:notifications"></mat-icon>
  <span *ngIf="unreadedCount" class="badge-notifications flex justify-center items-center bg-red-500 text-white h-3 w-3 rounded-full">{{unreadedCount}}</span>
</button>
